// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:768px){.pageWrapper--fixed .pageWrapper__inner,.pageWrapper--fixed .pageWrapper__inner--hideMobileSearch{padding-top:5.9rem}}.pageWrapper__inner--darkLayer:after{background:#000;content:\"\";height:100%;left:0;opacity:.2;position:fixed;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
